<template lang="pug">
div
  .tableTop10Grid
  .tableTop10Grid-head.show--bigScreens
    .tableTop10Grid-leftHead
      span {{ headerText.title }}
    .tableTop10Grid-rightHead
      th.tableTop10Grid-item.color--greyCharcoal30
        span.text--14.tableTop-url(@click="sortByType('url')")  {{ headerText.link }}
        i.tableTop10-arrowIcon.icon-arrow.icon-url
      th.tableTop10Grid-item.color--greyCharcoal30
        span.text--14.tableTop-reporterCount(@click="sortByType('reporterCount')")  {{ headerText.amount }}
        i.tableTop10-arrowIcon.icon-arrow.icon-reporterCount
      th.tableTop10Grid-item.color--greyCharcoal30
        span.text--14.tableTop-followerCount(@click="sortByType('followerCount')")  {{ headerText.bar }}
        i.tableTop10-arrowIcon.icon-arrow.icon-followerCount
</template>
<script>
import { disableSort, initCurrentSortByQueryStr } from '@/plugins/tool.js';
import { setGtag } from '@/plugins/gtag.js';

export default {
  props: {
    headerText: Object,
    type: String,
    sortable: Boolean
  },
  data() {
    return {
      currentSort: null
    };
  },
  mounted() {
    this.currentSort = initCurrentSortByQueryStr(
      this.$route.query.params,
      this.type
    );
  },
  methods: {
    sortByType(sortType) {
      if (!this.sortable) return;
      const data = {
        type: sortType,
        direction: -1
      };
      if (this.currentSort === null) {
        this.currentSort = data;
      } else if (this.currentSort.type === sortType) {
        switch (this.currentSort.direction) {
          case 0:
            this.currentSort.direction = -1;
            break;
          case -1:
            this.currentSort.direction = 1;
            break;
          default:
            this.currentSort.direction = 0;
        }
      } else {
        disableSort(this.currentSort.type);
        this.currentSort = data;
      }
      this.$emit('sortByType', this.currentSort);
      setGtag(
        'click',
        '已查核',
        'sort',
        sortType,
        this.$route.query.type !== 'verified'
      );
    }
  }
};
</script>
